import { css } from "@stubhub/broadway-foundation/css";

export const COMPONENT_CSS_VAR_NAMES = {
  stripeColor: "--component-header-stripe-color",
  backgroundColor: "--component-header-background-color",
} as const satisfies Record<string, `--component-${string}`>;

export const styledSolidBackgroundOverlay = css({
  width: "full",
  height: "full",
  borderBlockEndWidth: "primitives.100",
  borderBlockEndStyle: "solid",
  borderBlockEndColor: "var(--component-header-stripe-color)",
  backgroundColor: "var(--component-header-background-color, {colors.primitives.neutral.10})",
});
